import React from 'react';
import PropTypes from 'prop-types';
import { useColors } from '../../../hooks/useColors';
import { useTextReplacement } from '../../../hooks/useTextReplacement';

const StatusCard = ({ status, timestamp, className = '' }) => {
  const { semantic } = useColors();
  const { replace } = useTextReplacement();
  const isHealthy = status.toLowerCase() === 'healthy';
  
  return (
    <div className={`p-6 rounded-lg ${isHealthy ? semantic.successBg : semantic.errorBg} ${className}`}>
      <h3 className={`text-xl font-semibold mb-2 ${semantic.sectionHeading}`}>
        {replace('Status')}
      </h3>
      <p className={isHealthy ? semantic.successText : semantic.errorText}>
        {status.toUpperCase()}
      </p>
      <p className={semantic.formText}>
        {replace('Last Updated')}: {new Date(timestamp).toLocaleString()}
      </p>
    </div>
  );
};

StatusCard.propTypes = {
  status: PropTypes.string.isRequired,
  timestamp: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]).isRequired,
  className: PropTypes.string
};

export default StatusCard;

